package com.nonopn.skywatcher.common.app.pages.map.view.views

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.nonopn.skywatcher.common.app.pages.map.model.MainScreenModel
import com.nonopn.skywatcher.common.app.pages.map.model.weather.EtaHolder
import com.nonopn.skywatcher.common.app.pages.map.view.alerts.ShowETA
import com.nonopn.skywatcher.common.app.pages.map.view.alerts.ShowExpectedData


@Composable
fun ShowDataBigScreen(
    modifier: Modifier,
    model: MainScreenModel,
    eta: EtaHolder
) {
    Row(
        modifier,
        verticalAlignment = Alignment.CenterVertically
    ) {
        ShowExpectedData(
            Modifier.weight(1.0f),
            model,
            eta
        )

        CustomVerticalDivider()

        ShowETA(
            Modifier.weight(1.0f),
            eta
        )

        ShowAlertButton(
            Modifier.weight(1.0f),
            model,
        )
    }
}

@Composable
fun ShowDataTinyScreen(
    modifier: Modifier,
    model: MainScreenModel,
    eta: EtaHolder
) {
    Column(
        modifier,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Column(
            Modifier.weight(2.0f),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            ShowETA(
                Modifier,
                eta
            )

            ShowExpectedData(
                Modifier,
                model,
                eta
            )
        }

        ShowAlertButton(
            Modifier.weight(1.0f),
            model,
        )
    }
}

@Composable
fun ShowDataMediumScreen(
    modifier: Modifier,
    model: MainScreenModel,
    eta: EtaHolder
) {
    Row(
        modifier,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Column(
            Modifier.weight(2.0f),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            ShowETA(
                Modifier,
                eta
            )

            ShowExpectedData(
                Modifier,
                model,
                eta
            )
        }

        ShowAlertButton(
            Modifier.weight(1.0f),
            model,
        )
    }
}